module.exports = __webpack_public_path__ + "img/icon3.726d6710.png";